<template>
  <div class="login-wrap">
    <div class="login-box w1200">
      <img src="~@/assets/images/login_logo.png" alt="" class="login-img">
      <div class="login-form">
        <span class="fs20 fwn">元素魔方</span>
        <div class="under-line"></div>
        <div class="login-type">
          <div v-if="!binding" class="login-type-item fs16 fwn" :class="[form.login_type == 0 ? 'login-type-sel' : '']"
            @click="form.login_type = 0">
            微信登录</div>
          <div class="login-type-item fs16 fwn" :class="[form.login_type == 1 ? 'login-type-sel' : '']"
            @click="form.login_type = 1">
            密码{{ binding ? '绑定' : '登录' }}</div>
          <div class="login-type-item fs16 fwn" :class="[form.login_type == 2 ? 'login-type-sel' : '']"
            @click="form.login_type = 2">
            短信{{ binding ? '绑定' : '登录' }}</div>
        </div>
        <div class="login-wx" v-if="form.login_type == 0">
          <img class="login-qr-code" :src="qrcode" alt="">
          <div class="border"></div>
          <div class="border"></div>
          <div class="border"></div>
          <div class="border"></div>
        </div>
        <div class="login-pwd" v-if="form.login_type == 1">
          <div class="username-inp">
            <div class="icon flex-cc">
              <img src="~@/assets/images/login_user_icon.png" alt="">
            </div>
            <input type="text" name="phone" placeholder="请输入手机号" id="username" v-model="form.phone">
          </div>
          <div class="pwd-inp">
            <div class="icon flex-cc">
              <img src="~@/assets/images/login_pwd_icon.png" alt="">
            </div>
            <input type="password" name="password" placeholder="请输入密码" id="pwd" v-model="form.password">
            <div class="pwd-eye flex-cc">
              <img src="~@/assets/images/login_eye_icon.png" alt="">
            </div>
          </div>
        </div>
        <div class="login-msg login-by-msg" v-if="form.login_type == 2">
          <div class="phone-inp">
            <div class="icon flex-cc">
              <img src="~@/assets/images/login_phone_icon.png" alt="">
            </div>
            <input type="text" name="phone" placeholder="请输入手机号" id="phone" v-model="form.phone">
          </div>
          <div class="code-inp">
            <div class="icon flex-cc">
              <img src="~@/assets/images/login_msg_icon.png" alt="">
            </div>
            <input type="text" name="code" placeholder="请输入短信验证码" id="code" v-model="form.code">
            <div class="send-code-btn flex-cc" @click="sendCode">
              {{ text }}
            </div>
          </div>
        </div>
        <template v-if="binding">
          <el-button @click="handleSubmit()" :loading="loading" class="login-btn">登录{{ loading
            ?
            '中...' : '' }}</el-button>
        </template>
        <template v-else>
          <el-button v-if="form.login_type != 0" @click="handleSubmit()" :loading="loading" class="login-btn">登录{{
            loading
              ?
              '中...' : '' }}</el-button>
        </template>

        <div class="register-entry fs14 fw300">
          <span>还没账号？<router-link :to="{ path: '/auth/register' }">立即注册</router-link></span>
          <router-link :to="{ path: '/auth/forget' }">忘记密码?</router-link>
        </div>
      </div>
    </div>
    <!-- 滑动验证码 -->
    <Verify ref="verify" @success="captchaSuccess" mode="pop" :captchaType="form.captchaType"
      :imgSize="{ width: '330px', height: '155px' }"></Verify>
  </div>
</template>
<script>
import { sendCode } from "@/api/common";
import { getWeixinQrcode, checkByWeixinQrcode } from "@/api/auth";
import { validatePhone } from "@/utils/validate";
import { getStorage, setStorage, removeStorage } from "@/utils/auth";
import { v4 as uuidv4 } from 'uuid';
//引入组件
import Verify from "@/components/verifition/Verify";
export default {
  name: "AuthLogin",
  components: {
    Verify
  },
  data() {
    return {
      loading: false,
      disabled: false,
      countdown: 60,
      text: "发送验证码",
      config: {},
      form: {
        login_type: 0,
        phone: getStorage("loginPhone") || '',
        password: '',
        code: '',
        captchaType: "blockPuzzle",
        captchaVerification: "",
        csrf: '',
      },
      //0登录1发送验证码
      method: 0,
      qrcode: null,
      timer: null,
      checkQrcodeTimer: null,
      binding: false,
    };
  },
  created() {
    clearInterval(this.timer)
    clearInterval(this.checkQrcodeTimer)
    const alias = this.$route.query.alias || ''
    if (alias) {
      setStorage('alias', alias);
    }
    if (this.$route.query.back_url) {
      setStorage('back_url', this.$route.query.back_url);
    }
    this.$store.dispatch("Logout");
    this.getWeixinQrcode()
  },
  methods: {
    containsDomain(str) {
      const regex = /(http:\/\/|https:\/\/)?([a-zA-Z0-9_-]+\.)+[a-zA-Z]{2,}(\/\S*)?/;
      return regex.test(str);
    },
    getWeixinQrcode() {
      const that = this
      that.uuid = uuidv4();
      getWeixinQrcode({ uuid: this.uuid }).then((res) => {
        that.qrcode = res.data
        that.checkQrcodeTimer = setInterval(() => {
          that.checkByWeixinQrcode()
        }, 3000)
      }).catch((err) => {

      })
    },
    checkByWeixinQrcode() {
      checkByWeixinQrcode({ uuid: this.uuid }).then((res) => {
        if (res.data.scan == 1) {
          clearInterval(this.checkQrcodeTimer)
          console.log('扫码成功！')
          if (res.data.user_id) {
            this.$store.dispatch("qrcodeLogin", res.data).then(res => {
              this.$message.success('登录成功！')
              const back_url = getStorage('back_url') || '/';
              removeStorage("back_url");
              if (this.containsDomain(back_url)) {
                location.href = back_url
              } else {
                this.$router.push({
                  path: back_url
                });
              }

            });
          } else {
            this.$message.error('请绑定账号！')
            this.binding = true;
            this.form.openid = res.data.openid
            this.form.login_type = 1;
          }
        } else {
          console.log('扫码失败！')
        }
      }).catch((err) => {

      })
    },
    sendCode() {
      const that = this
      const _form = that.form;
      if (that.disabled) return
      if (!_form.phone) {
        this.$message({
          type: 'error',
          message: '请输入手机号'
        });
        return;
      }
      if (!validatePhone(_form.phone)) {
        this.$message({
          type: 'error',
          message: '请输入正确的手机号码'
        });
        return;
      }
      console.log(_form)
      if (!_form.captchaVerification) {
        that.method = 1;
        this.$refs.verify.show()
        return;
      }
      that.disabled = true
      sendCode(that.form).then((res) => {
        that.timer = setInterval(() => {
          that.countdown--
          this.text = "重新发送(" + that.countdown + "s)"
          if (that.countdown == 0) {
            that.disabled = false
            that.text = '发送验证码'
            that.countdown = 60
            clearInterval(that.timer)
          }
        }, 1000)

        if (res.code == 0) {
          this.form.csrf = res.data.csrf;
          this.$message({
            type: 'success',
            message: '短信发送成功'
          });
        } else {
          this.$message({
            type: 'error',
            message: res.msg
          });
        }
      }).catch((err) => {
        console.log(err)
      })
    },
    captchaSuccess(params) {
      console.log(params);
      this.form = {
        ...this.form,
        ...params,
      }
      if (this.method == 0) {
        this.handleSubmit()
      } else {
        this.sendCode()
      }
      // params 返回的二次验证参数, 和登录参数一起回传给登录接口，方便后台进行二次验证
    },
    //提交登录请求
    handleSubmit() {
      const that = this;
      const _form = this.form;
      if (!_form.phone) {
        this.$message({
          type: 'error',
          message: '请输入手机号'
        });
        return;
      }
      if (!validatePhone(_form.phone)) {
        this.$message({
          type: 'error',
          message: '请输入正确的手机号码'
        });
        return;
      }
      if (_form.login_type == 1 && !_form.password) {
        this.$message({
          type: 'error',
          message: '请输入密码'
        });
        return;
      }
      if (_form.login_type == 2 && !_form.code) {
        this.$message({
          type: 'error',
          message: '请输入验证码'
        });
        return;
      }
      if (!_form.captchaVerification) {
        this.method = 0;
        this.$refs.verify.show()
        return;
      }
      this.loading = true;
      this.$store.dispatch("login", _form).then(res => {
        this.loading = false;
        this.form.captchaVerification = '';
        this.form.csrf = '';
        this.$message.success('登录成功！')
        const back_url = getStorage('back_url') || '/';
        removeStorage("back_url");
        if (this.containsDomain(back_url)) {
          location.href = back_url
        } else {
          this.$router.push({
            path: back_url
          });
        }
      }).catch(() => {
        this.form.captchaVerification = '';
        this.form.csrf = '';
        this.loading = false;
      });
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/styles/login.less';
</style>
